// Cache for reusing canvas to avoid repeated DOM element creation
let cachedCanvas: HTMLCanvasElement | null = null;

export const imageDataToBase64 = (
	imageData: ImageData,
	format: 'jpeg' | 'png' = 'jpeg',
	quality: number = 0.8 // Higher default quality for high-res photos
): string => {
	// Reuse canvas if dimensions match, otherwise create/resize
	if (!cachedCanvas) {
		cachedCanvas = document.createElement('canvas');
	}

	// Resize canvas only if needed to avoid unnecessary operations
	if (cachedCanvas.width !== imageData.width || cachedCanvas.height !== imageData.height) {
		cachedCanvas.width = imageData.width;
		cachedCanvas.height = imageData.height;
	}

	// Get the 2D context and put the ImageData onto it
	const ctx = cachedCanvas.getContext('2d');
	if (!ctx) {
		throw new Error('Could not get 2D context');
	}

	// Put the ImageData onto the canvas
	ctx.putImageData(imageData, 0, 0);

	// Convert to base64 data URL with higher quality for better photo results
	const dataURL = cachedCanvas.toDataURL(`image/${format}`, quality);

	// Remove the data:image/jpeg;base64, prefix to get just the base64 string
	return dataURL.split(',')[1];
};
